var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconsOtherProgress = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.256 12.616L12.488 7.384M7.6 2H12.4C16.4 2 18 3.6 18 7.6V12.4C18 16.4 16.4 18 12.4 18H7.6C3.6 18 2 16.4 2 12.4V7.6C2 3.6 3.6 2 7.6 2Z",
    stroke: "#1B1B1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58401 8.69613C7.84498 8.69613 8.09526 8.59246 8.2798 8.40792C8.46433 8.22338 8.56801 7.9731 8.56801 7.71213C8.56801 7.45115 8.46433 7.20087 8.2798 7.01633C8.09526 6.8318 7.84498 6.72813 7.58401 6.72813C7.32303 6.72813 7.07275 6.8318 6.88821 7.01633C6.70368 7.20087 6.60001 7.45115 6.60001 7.71213C6.60001 7.9731 6.70368 8.22338 6.88821 8.40792C7.07275 8.59246 7.32303 8.69613 7.58401 8.69613ZM12.816 13.2721C13.077 13.2721 13.3273 13.1685 13.5118 12.9839C13.6963 12.7994 13.8 12.5491 13.8 12.2881C13.8 12.0272 13.6963 11.7769 13.5118 11.5923C13.3273 11.4078 13.077 11.3041 12.816 11.3041C12.555 11.3041 12.3047 11.4078 12.1202 11.5923C11.9357 11.7769 11.832 12.0272 11.832 12.2881C11.832 12.5491 11.9357 12.7994 12.1202 12.9839C12.3047 13.1685 12.555 13.2721 12.816 13.2721Z",
    stroke: "#1B1B1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconsOtherProgress);
export default ForwardRef;